import { NgModule } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

import {
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  Book,
  Check,
  Download,
  Edit,
  Eye,
  EyeOff,
  Files,
  FileText,
  Frown,
  Headphones,
  Heart,
  HelpCircle,
  Image,
  Lock,
  LogOut,
  Megaphone,
  Mail,
  Maximize,
  Minimize,
  Meh,
  MessageCircle,
  Info,
  Monitor,
  Pencil,
  Paperclip,
  Phone,
  Plus,
  Share2,
  Search,
  Send,
  Settings,
  Smile,
  Star,
  StarHalf,
  Trash,
  User,
  UserRound,
  Unlock,
  Wifi,
  Upload,
  X,
  Globe,
  ChevronRight,
  ChevronLeft,
  Menu,
  CornerDownRight,
  Repeat,
  Home,
  Bot
} from 'lucide-angular';

const icons = {
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  Book,
  Check,
  Download,
  Edit,
  Eye,
  EyeOff,
  Files,
  FileText,
  Frown,
  Headphones,
  Heart,
  HelpCircle,
  Image,
  Lock,
  LogOut,
  Mail,
  Maximize,
  Megaphone,
  Meh,
  MessageCircle,
  Info,
  Minimize,
  Monitor,
  Pencil,
  Paperclip,
  Phone,
  Plus,
  Share2,
  Search,
  Send,
  Settings,
  Smile,
  Star,
  StarHalf,
  Trash,
  User,
  UserRound,
  Unlock,
  Wifi,
  Upload,
  X,
  Globe,
  ChevronRight,
  ChevronLeft,
  Menu,
  CornerDownRight,
  Repeat,
  Home,
  Bot
};

@NgModule({
  imports: [
    LucideAngularModule.pick(icons)
  ],
  exports: [
    LucideAngularModule
  ]
})

export class IconsModule {}
